import React from 'react'
import logo from '../../asset/logo2.png'
import { FaEnvelope, FaFacebook, FaInstagram, FaLocationDot, FaPhone, FaTwitter } from 'react-icons/fa6'
import { FaLinkedin } from 'react-icons/fa'
import { useCombinedpackageQuery } from '../../../redux/API/PackageApi'
import { Link } from 'react-router-dom'
const Footer = () => {
const { data: combinedData } = useCombinedpackageQuery();


  return (
    <>
      <footer className='mt-5 py-4'>
        <div className="container">
          <div className="row gy-3">
            <div className="col-12">
              <img src={logo} alt="" width={140} />
            </div>
            <div className="col-lg-3">
              <p className='text-white text-justify'> At GumneJao, we want your travel experience to be smooth and unforgettable! Whether you have a question, need assistance, or want to plan your next trip, feel free to reach out. Our team is always ready to help you with the best travel solutions.</p>
            </div>

            <div className="col-lg-3">
              <h5 className='text-warning'>Top Package</h5>
              <ul className='ps-0'>
              {combinedData?.data?.slice(0,5)?.map((packageItem) => (
                <li className='list-unstyled text-white mb-2 d-flex' ey={packageItem?._id}>
                <Link to={`/packages/detail/${packageItem?.slug}`} className="text-decoration-none text-white">{packageItem?.name}</Link>
        </li>
              ))
              }
        </ul>
            </div>

            <div className="col-lg-4">
              <h5 className='text-warning'>Contact Us</h5>
              <ul className='ps-0'>
                <li className='list-unstyled text-white mb-2 d-flex'><FaLocationDot className='text-warning fs-3 me-2 ' />
                  <span>
                    Address : 303, Tower 4, Assotech Business Cresterra, Sector 135, Noida 201305

                  </span>

                </li>
                <li className='list-unstyled text-white mb-2'><FaPhone className='text-warning me-2' />  9873018222</li>
                <li className='list-unstyled text-white mb-2'><FaEnvelope className='text-warning me-2' />travanshholidays@gmail.com </li>
              </ul>
            </div>

            <div className='col-lg-2'>
              <h5 className='text-warning'>Connect Us</h5>
              <div>
                <span className='me-2 fs-3 text-white'><FaInstagram /></span>
                <span className='me-2 fs-3 text-white'><FaTwitter /></span>
                <span className='me-2 fs-3 text-white'><FaFacebook /></span>
                <span className='me-2 fs-3 text-white'><FaLinkedin /></span>
              </div>
            </div>

            <div className="col-12 mt-5">
              <div className="row">
                <div className="col-lg-6">
                  <p className='mb-0 text-white'>Copyright © <span className='text-warning'>GhumneJao</span>. All Rights Reserved</p>
                </div>
                <div className="col-lg-6 text-lg-end">
                  <p className='mb-0 text-white'>Designed by Infotiqq</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer